var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminNextIframe',{attrs:{"path":"/collections/","query":{ clientId: _vm.$route.params.id }},on:{"navigate":_vm.onNavigate,"back":_vm.onBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }